import { IColumns } from '../../components/Table'

export type CompaniesColumnKeys =
  | 'id'
  | 'name'
  | 'postCode'
  | 'personalContact'
  | 'phone'
  | 'kycStatus'
  | 'created'
  | 'actions'

export const columns: IColumns<CompaniesColumnKeys>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'name',
    label: 'COMPANY NAME',
  },
  // {
  //   id: 'postCode',
  //   label: 'CODE',
  // },
  // {
  //   id: 'personalContact',
  //   label: 'CONTACT PERSON',
  // },
  // {
  //   id: 'phone',
  //   label: 'PHONE',
  // },
  {
    id: 'kycStatus',
    label: 'KYC STATUS',
    format: (value) =>
      value
        ?.toString()
        .toLowerCase()
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'created',
    label: 'DATE',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
  {
    id: 'actions',
    label: 'ACTIONS',
  },
]
